import React, {useState, useEffect} from "react";
import constants from '../lib/constants';
import ProjectedStartersTable from "../lib/components/ProjectedStartersTable";
import viewUtil from '../lib/viewUtil';

const getRoundAndPick = (pickNumber) => ({ round: Math.ceil(pickNumber / 12), pick: pickNumber % 12 || 12 });
const { managerList, positions } = constants;

const RostersModal = ({ players, draftPicks, permissions, managerDraftStats }) => {
    const [selectedManager, updateSelectedManager] = useState(managerList.findIndex(managerName => managerName === permissions) > -1 ? permissions : managerList[0]);
    const [managerPlayers, updateManagerPlayers] = useState(players.filter(player => player.manager === selectedManager));
    const dp = draftPicks.map((draftPick, index) => ({ ...draftPick, index: index + 1 }));
    const [managerDraftedPlayers, updateManagerDraftedPlayers] = useState(dp.filter(draftPick => draftPick.manager === selectedManager));

    useEffect(() => {
        updateManagerPlayers(players.filter(player => player.manager === selectedManager));
        updateManagerDraftedPlayers(draftPicks.map((dp, index) => ({ ...dp, index: index + 1 })).filter(draftPick => draftPick.manager === selectedManager));
    }, [selectedManager]);

    const draftedPlayersData = managerDraftedPlayers.map(player => {
        const playerOnTeam = players.find(p => p.id === player.pickId);
        if (!playerOnTeam) {
            return null;
        }
        return {
            ...player,
            name: player.pick,
            posname: playerOnTeam.posname,
            nflteam: playerOnTeam.nflteam,
            yahooleaguerank: playerOnTeam.yahooleaguerank || 250, // Default to 250 if not available
        };
    }).filter(player => player !== null);

    return (
        <>
            <div id="draft-roster-table">
                <div>
                    <select onChange={(e) => updateSelectedManager(e.currentTarget.value)} className="form-select form-select-lg bg-dark text-white border-secondary" value={selectedManager}>
                        {managerList.map((manager) => (
                            <option key={`${manager}-dropdown-option`} value={manager}>{manager}</option>
                        ))}
                    </select>
                    <div>
                        <div className="row">
                            {positions.map((position) => (
                                <div className="col-6" key={`${position}-count`}>{position}: {managerPlayers.filter(player => player.posname === position).length}</div>
                            ))}
                        </div>
                        <div># Players + Picks: {managerPlayers.length + managerDraftedPlayers.length}/17</div>
                        <div># Contract years: {managerPlayers.reduce((acc, cur) => acc + cur.contract, 0)}/34</div>
                    </div>
                </div>
                <div>
                    <h4>Projected Starters</h4>
                    <ProjectedStartersTable 
                        managerPlayerData={[...managerPlayers, ...draftedPlayersData]} />
                </div>
                <div className="table-responsive">
                    <table className="table table-dark table-striped table-bordered caption-top">
                        <caption>{selectedManager}'s Roster + Picks</caption>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Player</th>
                                <th scope="col"><i className="bi bi-clipboard-check-fill"></i></th>
                                <th scope="col">Team</th>
                                <th scope="col">Position</th>
                                <th scope="col">Age</th>
                                <th scope="col">Y!</th>
                            </tr>
                        </thead>
                        <tbody>
                            {managerPlayers.map((player, index) => {
                                return (
                                    <tr key={`managerplayer-${index}`}>
                                        <td>{index + 1}</td>
                                        <td>{player.name}</td>
                                        <td className="text-center">{player.contract}</td>
                                        <td>{player.nflteam}</td>
                                        <td>{player.posname}</td>
                                        <td>{viewUtil.getAge(player.birthdate) ?? '--'}</td>
                                        <td>{player.yahooleaguerank || '--'}</td>
                                    </tr>
                                )
                            })}
                            {managerDraftedPlayers.map((player, index) => {
                                const playerOnTeam = player.pickId ? players.find(p => p.id === player.pickId) : null;
                                return (
                                    <tr key={`managerDraftedPlayer-${index}`} className="table-info">
                                        <td>{managerPlayers.length + index + 1}</td>
                                        <td>{player.pick ? player.pick : `Rd ${getRoundAndPick(player.index).round} Pick ${getRoundAndPick(player.index).pick}`}</td>
                                        <td>--</td>
                                        <td>{playerOnTeam ? playerOnTeam.nflteam : '--'}</td>
                                        <td>{playerOnTeam ? playerOnTeam.posname : '--'}</td>
                                        <td>{viewUtil.getAge(playerOnTeam?.birthdate) ?? '--'}</td>
                                        <td>{playerOnTeam?.yahooleaguerank ? playerOnTeam.yahooleaguerank : '--'}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default RostersModal;